var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.567 90 H 20.433 c -5.073 0 -9.2 -4.127 -9.2 -9.199 V 43.338 c 0 -4.245 2.883 -7.923 7.011 -8.945 c 17.754 -4.396 35.758 -4.396 53.512 0 c 4.128 1.021 7.012 4.7 7.012 8.945 v 37.463 C 78.768 85.873 74.641 90 69.567 90 z M 45 39.099 c -8.297 0 -16.594 1.02 -24.833 3.06 c -0.55 0.136 -0.934 0.621 -0.934 1.179 v 37.463 c 0 0.661 0.538 1.199 1.2 1.199 h 49.135 c 0.662 0 1.2 -0.538 1.2 -1.199 V 43.338 c 0 -0.558 -0.384 -1.043 -0.934 -1.179 C 61.595 40.119 53.297 39.099 45 39.099 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 66.263 41.256 c -2.209 0 -4 -1.791 -4 -4 V 25.262 C 62.263 15.744 54.519 8 45 8 s -17.262 7.744 -17.262 17.262 v 11.994 c 0 2.209 -1.791 4 -4 4 s -4 -1.791 -4 -4 V 25.262 C 19.738 11.333 31.07 0 45 0 s 25.263 11.333 25.263 25.262 v 11.994 C 70.263 39.465 68.472 41.256 66.263 41.256 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 56.68,
    r: 7.5,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 74.079 c -2.209 0 -4 -1.791 -4 -4 v -7.703 c 0 -2.209 1.791 -4 4 -4 s 4 1.791 4 4 v 7.703 C 49 72.288 47.209 74.079 45 74.079 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.59c589383b73a6b243d907b9622bd200.svg";
export { ForwardRef as ReactComponent };